import { useCallback, useState, useMemo } from 'react';

export const useBooleanState = (defaultValue: boolean = false) => {
  const [value, setValue] = useState(defaultValue);

  const on = useCallback(() => {
    setValue(true);
  }, []);

  const off = useCallback(() => {
    setValue(false);
  }, []);

  const toggle = useCallback(() => {
    setValue((prev) => !prev);
  }, []);

  return useMemo(
    () => ({
      isActive: value,
      off,
      on,
      setValue,
      toggle,
    }),
    [off, on, toggle, value],
  );
};

export type BooleanState = ReturnType<typeof useBooleanState>;
